module.exports = __webpack_public_path__ + "static/media/person.7a537b4e.svg";